export const uniqueStack = (array, size) => {
    const items = [...array];
    return function (item) {
        if (items.indexOf(item) === -1) items.unshift(item);
        else items.splice(0, 0, ...items.splice(items.indexOf(item), 1));
        return items.slice(0, size);
    };
};
